// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__17_Bx","content":"Consent_content__2VKeJ","footer":"Consent_footer__3KY-Z"};